<div>

  <app-applied-tag-group-table *ngFor="let group of tagGroups"
                               [group]="group"
                               [target]="entityConnection"
                               [campaignId]="campaignId"
                               class="d-block mb-0125">
  </app-applied-tag-group-table>

  <button class="mimic-link txt-14 c-pointer"
          type="button"
          (click)="openAddConnectionInfoDialog()">
    <i class="fa-plus fal mr-0050"></i>Add Connection Info
  </button>

</div>
